import { FC } from "react";
import BondAppFormContext from "../contexts/BondAppFormContext";
import useFormSchema from "../hooks/useFormSchema";

interface IAppStateProvider {
  children: JSX.Element | JSX.Element[];
}

const AppStateProvider: FC<IAppStateProvider> = (props) => {
  const { children } = props;

  const formSchema = useFormSchema();

  return (
    <BondAppFormContext.Provider value={formSchema}>
      { children }
    </BondAppFormContext.Provider>
  )
}

export default AppStateProvider;